import { Util } from '@antv/g6';
import { DrawOpts, ShapeOptions } from '../../../../types';
import { ItemState } from '../../../../constants';
import { shapeNames } from '../../../../shapes/constants';

const getErrorHighlightOptions = (options: ShapeOptions) => ({
  errorHighlightWrapperStyle:
    options?.stateStyles[ItemState.Error][shapeNames.errorHighlight] || {},
});

const shouldErrorHighlightShow = (hasError = false) => hasError;

const getErrorHighlightDetails = ({ size, options }: Pick<DrawOpts, 'size' | 'options'>) => {
  const [keyShapeWidth, keyShapeHeight] = size;

  const { errorHighlightWrapperStyle = {} } = getErrorHighlightOptions(options);
  const [paddingTop, paddingRight, paddingBottom, paddingLeft] = Util.formatPadding(
    errorHighlightWrapperStyle.padding,
  );

  return {
    height: paddingTop + keyShapeHeight + paddingBottom,
    width: paddingRight + keyShapeWidth + paddingLeft,
    x: -paddingLeft,
    y: -paddingTop,
  };
};

export const drawErrorHighlight = ({ size, options, group, model }: DrawOpts) => {
  const { errorHighlightWrapperStyle } = getErrorHighlightOptions(options);
  const { height, width, x, y } = getErrorHighlightDetails({
    size,
    options,
  });

  return group.addShape('rect', {
    name: shapeNames.errorHighlight,
    className: shapeNames.errorHighlight,
    draggable: true,
    attrs: {
      x,
      y,
      width,
      height,
      ...errorHighlightWrapperStyle,
    },
    visible: shouldErrorHighlightShow(model?.hasError),
  });
};

export const updateErrorHighlight = ({ size, group, model, options }: DrawOpts) => {
  const errorHighlightShape = group.findByClassName(shapeNames.errorHighlight);

  if (!errorHighlightShape) return;

  if (shouldErrorHighlightShow(model?.hasError)) errorHighlightShape.show();
  // Don't bother with the rest of the calculations, as it is hidden anyway
  else return errorHighlightShape.hide();

  const { height, width, x, y } = getErrorHighlightDetails({
    size,
    options,
  });

  errorHighlightShape.attr({
    x,
    y,
    width,
    height,
  });
};
